import { useTranslation } from '../i18n';
import { PLATFORM_VERSION } from '../brand';
import { PlatformFootnote } from '../primitives';

/**
 * Emporium footnote - composes the shared PlatformFootnote with catalog-surface content.
 *
 * Legacy hooked into /api/stats via `usePlatformStats` to render a live entry count. That
 * stats fetch hasn't been ported to the unified SPA yet - entries renders as `-` until it is.
 */
export function EmporiumFootnote() {
    const t = useTranslation();
    const entries = t('emporium.footnoteEntries', { n: '-' });
    const left = t('emporium.footnoteLeft', { version: PLATFORM_VERSION, entries });

    return <PlatformFootnote cap="wide" left={left} right={t('footer.ffxivDisclaimer')} />;
}
